import { useCallback, useContext } from 'react';
import { AdyenComponentContainer } from '@/components/expressPayment/AdyenComponentContainer';
import { useAdyenApplePay } from './useAdyenApplePay';
import type { ExpressCheckoutComponentProps } from '@/utils/expressPayment';
import { CheckoutContext } from '@/context/CheckoutContext';
import { PaymentMethodEnum } from '@/types/common';
import { trackAndNotifyPaymentClick } from '@/utils/paymentClickEvents';

export const AdyenApplePay = ({ onReady }: ExpressCheckoutComponentProps) => {
  const context = useContext(CheckoutContext);

  const onClick = useCallback(
    (resolve: () => void, _reject: () => void) => {
      trackAndNotifyPaymentClick(context, PaymentMethodEnum.APPLE_PAY);
      resolve();
    },
    [context]
  );

  const { applePayElement } = useAdyenApplePay({ onReady, onClick });

  return <AdyenComponentContainer element={applePayElement} />;
};
